module.exports = "https://cdn.littlereply.com/tt/resource/earn_guide_step_3@3x.3950b1eec9d5735c671c7ba41b414c1a.png";